// SVG pattern backgrounds per theme — subtle, light-mode friendly
// Each pattern is a tile rendered semi-transparently in the card background

function svg(content, size = 80, opacity = 0.12) {
  return `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}' viewBox='0 0 ${size} ${size}'>${content}</svg>`;
}

function musicPattern() {
  const o = 0.22;
  const notes = `
    <g fill='%236B2BD9' fill-opacity='${o + 0.05}'>
      <circle cx='22' cy='44' r='5'/>
      <rect x='25' y='14' width='2.5' height='30'/>
      <path d='M25 14 q12 3 12 12' stroke='%236B2BD9' stroke-width='2.2' fill='none' stroke-opacity='${o + 0.05}'/>
      <circle cx='118' cy='110' r='5'/>
      <rect x='121' y='80' width='2.5' height='30'/>
      <path d='M121 80 q12 3 12 12' stroke='%236B2BD9' stroke-width='2.2' fill='none' stroke-opacity='${o + 0.05}'/>
      <circle cx='70' cy='130' r='4'/>
      <rect x='72.5' y='104' width='2' height='26'/>
    </g>`;
  // Streamers: curvy ribbons in pink and yellow
  const streamers = `
    <path d='M0 70 q20 -18 40 0 t40 0 t40 0 t40 0' stroke='%23FF3DA5' stroke-width='2.2' fill='none' stroke-opacity='${o}'/>
    <path d='M0 24 q20 14 40 0 t40 0 t40 0 t40 0' stroke='%23FFCC00' stroke-width='2' fill='none' stroke-opacity='${o + 0.03}'/>`;
  // Confetti: tiny squares + triangles in 5 colors, scattered
  const confetti = `
    <g fill-opacity='${o + 0.05}'>
      <rect x='8' y='8' width='5' height='5' fill='%23FF3DA5' transform='rotate(20 10 10)'/>
      <rect x='98' y='18' width='5' height='5' fill='%2300C2A8' transform='rotate(-15 100 20)'/>
      <rect x='52' y='90' width='5' height='5' fill='%23FFCC00' transform='rotate(40 54 92)'/>
      <rect x='140' y='52' width='5' height='5' fill='%23E63946' transform='rotate(-30 142 54)'/>
      <rect x='6' y='128' width='5' height='5' fill='%236B2BD9' transform='rotate(10 8 130)'/>
      <path d='M88 60 l5 -8 l5 8 z' fill='%23FF3DA5'/>
      <path d='M40 100 l5 -8 l5 8 z' fill='%2300C2A8'/>
      <path d='M132 122 l5 -8 l5 8 z' fill='%23FFCC00'/>
      <circle cx='52' cy='28' r='2.5' fill='%23E63946'/>
      <circle cx='106' cy='66' r='2.5' fill='%2300C2A8'/>
      <circle cx='150' cy='10' r='2.5' fill='%236B2BD9'/>
    </g>`;
  return svg(`${confetti}${streamers}${notes}`, 160, 0);
}

// World Cup pattern: football icons (soccer balls), pennant flags and
// gold stars on a 160×160 tile. Subtle enough not to fight the text.
function wkPattern() {
  const o = 0.18;
  // Soccer balls (white circle with black pentagon dots)
  const balls = `
    <g fill-opacity='${o + 0.04}'>
      <circle cx='28' cy='30' r='10' fill='%23ffffff' stroke='%23111' stroke-width='1.6'/>
      <polygon points='28,24 31,28 30,32 26,32 25,28' fill='%23111'/>
      <circle cx='120' cy='118' r='10' fill='%23ffffff' stroke='%23111' stroke-width='1.6'/>
      <polygon points='120,112 123,116 122,120 118,120 117,116' fill='%23111'/>
      <circle cx='80' cy='80' r='7' fill='%23ffffff' stroke='%23111' stroke-width='1.4'/>
      <polygon points='80,76 82,79 81,82 79,82 78,79' fill='%23111'/>
    </g>`;
  // Pennant string with little triangle flags in red/blue/yellow
  const pennants = `
    <g fill-opacity='${o + 0.06}'>
      <path d='M0 56 Q40 70 80 56 T160 56' stroke='%23111' stroke-width='1' fill='none' stroke-opacity='${o}'/>
      <polygon points='12,56 18,56 15,64' fill='%23E63946'/>
      <polygon points='28,58 34,58 31,66' fill='%23FFD700'/>
      <polygon points='44,58 50,58 47,66' fill='%231E88E5'/>
      <polygon points='60,57 66,57 63,65' fill='%23E63946'/>
      <polygon points='76,56 82,56 79,64' fill='%23FFD700'/>
      <polygon points='92,57 98,57 95,65' fill='%231E88E5'/>
      <polygon points='108,58 114,58 111,66' fill='%23E63946'/>
      <polygon points='124,58 130,58 127,66' fill='%23FFD700'/>
      <polygon points='140,57 146,57 143,65' fill='%231E88E5'/>
    </g>`;
  // Gold stars (5-pointed, scattered)
  const stars = `
    <g fill='%23FFD700' fill-opacity='${o + 0.1}'>
      <polygon points='62,16 64,22 70,22 65,26 67,32 62,28 57,32 59,26 54,22 60,22'/>
      <polygon points='142,32 144,38 150,38 145,42 147,48 142,44 137,48 139,42 134,38 140,38'/>
      <polygon points='14,120 16,126 22,126 17,130 19,136 14,132 9,136 11,130 6,126 12,126'/>
      <polygon points='100,140 102,146 108,146 103,150 105,156 100,152 95,156 97,150 92,146 98,146'/>
    </g>`;
  return svg(`${pennants}${balls}${stars}`, 160, 0);
}

export function patternFor(themeId) {
  const o = 0.18;
  switch (themeId) {
    case "muziek":
      return musicPattern();
    case "wk":
      return wkPattern();
    case "sinterklaas":
      return svg(`<g fill='%23C8102E' fill-opacity='${o}'><circle cx='20' cy='20' r='6'/><circle cx='60' cy='60' r='6'/><path d='M20 50 l8 -14 l8 14 z' fill='%23C8102E'/><circle cx='50' cy='25' r='3' fill='%23FFCC00' fill-opacity='${o + 0.1}'/></g>`);
    case "kerst":
      return svg(`<g fill='%230E5C2F' fill-opacity='${o}'><path d='M14 50 l8 -22 l8 22 z'/><path d='M16 60 l6 -16 l6 16 z'/><circle cx='55' cy='30' r='4' fill='%23C8102E'/><path d='M55 22 v16 M47 30 h16' stroke='%23FFCC00' stroke-width='1' stroke-opacity='${o + 0.1}'/></g>`);
    case "pasen":
      return svg(`<g fill-opacity='${o}'><ellipse cx='20' cy='25' rx='7' ry='9' fill='%23F5A623'/><ellipse cx='55' cy='55' rx='7' ry='9' fill='%237ED321'/><circle cx='55' cy='20' r='4' fill='%23E63946'/></g>`);
    case "halloween":
      return svg(`<g fill='%23FF7518' fill-opacity='${o + 0.05}'><circle cx='20' cy='20' r='8'/><circle cx='60' cy='55' r='6'/><path d='M16 20 q4 -4 8 0' stroke='%23111' stroke-width='1.5' fill='none'/></g>`);
    case "valentijn":
      return svg(`<g fill='%23E63946' fill-opacity='${o}'><path d='M20 30 c-6 -8 -14 -2 -8 6 l8 8 l8 -8 c6 -8 -2 -14 -8 -6z'/><path d='M55 60 c-4 -6 -10 -2 -6 4 l6 6 l6 -6 c4 -6 -2 -10 -6 -4z'/></g>`);
    case "verjaardag":
      return svg(`<g fill-opacity='${o}'><circle cx='15' cy='20' r='4' fill='%23FF3B30'/><circle cx='55' cy='35' r='4' fill='%23FFCC00'/><circle cx='30' cy='55' r='4' fill='%23007AFF'/><circle cx='65' cy='15' r='3' fill='%2334C759'/><rect x='10' y='10' width='3' height='3' fill='%23FF3B30' transform='rotate(20 11 11)'/></g>`);
    case "bruiloft":
      return svg(`<g fill='%23B8860B' fill-opacity='${o}'><circle cx='25' cy='30' r='6' stroke='%23B8860B' stroke-width='2' fill='none'/><circle cx='35' cy='30' r='6' stroke='%23B8860B' stroke-width='2' fill='none'/></g>`);
    case "zomer":
      return svg(`<g fill-opacity='${o}'><circle cx='20' cy='20' r='10' fill='%23FFCC00'/><path d='M55 60 q5 -10 10 0' stroke='%2300A6B8' stroke-width='2' fill='none' stroke-opacity='${o + 0.2}'/></g>`);
    case "winter":
      return svg(`<g stroke='%233A6EA5' stroke-width='1.5' fill='none' stroke-opacity='${o + 0.1}'><path d='M20 10 v20 M10 20 h20 M13 13 l14 14 M27 13 l-14 14'/><path d='M55 50 v15 M48 57 h14'/></g>`);
    case "sport":
      return svg(`<g fill='%230E5C2F' fill-opacity='${o}'><circle cx='20' cy='25' r='7'/><circle cx='55' cy='55' r='6' stroke='%23FF3B30' stroke-width='2' fill='none'/></g>`);
    case "natuur":
      return svg(`<g fill='%232E7D32' fill-opacity='${o}'><path d='M20 50 l8 -22 l8 22 z'/><circle cx='60' cy='30' r='4'/></g>`);
    case "reizen":
      return svg(`<g fill='%231E88E5' fill-opacity='${o}'><path d='M10 30 l30 -10 l5 5 l-25 15 z'/><circle cx='60' cy='55' r='5'/></g>`);
    case "bedrijfsfeest":
      return svg(`<g fill='%23FFCC00' fill-opacity='${o}'><rect x='15' y='20' width='4' height='30'/><rect x='55' y='15' width='4' height='40'/><circle cx='35' cy='55' r='4'/></g>`);
    default:
      return null;
  }
}
